import widgetSlice from './slice';

export const {
  fetchWidget,
  fetchWidgetError,
  fetchWidgetSuccess,
  saveWidgetData,
  saveWidgetDataSuccess,
  addEnabledWidget,
  addEnabledWidgetSuccess,
  setDefaultWidgetState,
  verifyWidget,
  verifyWidgetSuccess,
  verifyWidgetError,
  cancelVerifyWidget,
} = widgetSlice.actions;
export default widgetSlice.reducer;

export * from './types';
